import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {Button, Divider, message, Popconfirm, Popover, Table, Tag} from 'antd';
import {DeleteOutlined} from '@ant-design/icons';
import * as Constants from '../../../constants';
import cloneDeep from 'lodash.clonedeep';
import './styles.css';
import {cloudFunctions, db} from '../../../config/Fire';

const {Column} = Table;

const TableClientsSurveys = ({data, surveysAssigned}) => {
    const dataSource = cloneDeep(data)
    const [isAssigningUser, setIsAssigningUser] = useState(false)

    const renderSurveyAction = (record) => {
        if (record.surveysAssignedIds && surveysAssigned && surveysAssigned[record.surveysAssignedIds[0]]) {
            return (
                <span>
                    <Tag>{Constants.SurveysTypes[surveysAssigned[record.surveysAssignedIds[0]].surveyType]}</Tag>
                    <Divider type="vertical"/>
                    <Popconfirm title={`¿Desea borrar la encuesta asignada?`} okText="SI" cancelText="NO"
                                onConfirm={() => {
                                    removeSurvey(record.id, record.surveysAssignedIds[0])
                                }}>
                        <Button className="buttonSurveyTableCont"><DeleteOutlined/></Button>
                    </Popconfirm>
                </span>
            );
        } else {
            var content = (
                <div className="accionCont">
                    <Popconfirm title={`¿Desea asignar la encuesta ${Constants.SurveysTypes.PL01}?`} okText="SI"
                                cancelText="NO" onConfirm={() => assignSurvey(record.id, Constants.SurveysTypes.PL01)}>
                        <Button>{Constants.SurveysTypes.PL01}</Button>
                    </Popconfirm>
                    <Divider type="vertical"/>
                    <Popconfirm title={`¿Desea asignar la encuesta ${Constants.SurveysTypes.PL02}?`} okText="SI"
                                cancelText="NO" onConfirm={() => assignSurvey(record.id, Constants.SurveysTypes.PL02)}>
                        <Button>{Constants.SurveysTypes.PL02}</Button>
                    </Popconfirm>
                    <Divider/>
                    <Popconfirm title={`¿Desea asignar la encuesta ${Constants.SurveysTypes.PL03}?`} okText="SI"
                                cancelText="NO" onConfirm={() => assignSurvey(record.id, Constants.SurveysTypes.PL03)}>
                        <Button>{Constants.SurveysTypes.PL03}</Button>
                    </Popconfirm>
                </div>
            );
            return (
                <Popover content={content}>
                    <Button type="primary">Asignar</Button>
                </Popover>);
        }
    }

    const assignSurvey = (id, value) => {
        var surveyKey = ""
        Object.keys(Constants.SurveysTypes).forEach(key => {
            if (Constants.SurveysTypes[key] === value) {
                surveyKey = key
            }
        });
        var userToNotify = null
        dataSource.forEach(user => {
            if (user.id === id) {
                userToNotify = user
            }
        });
        if (userToNotify && surveyKey !== "") {
            setIsAssigningUser(true)
            cloudFunctions.tryAssignSurvey({
                userId: id,
                userEmail: userToNotify.email,
                userToken: userToNotify.token,
                platform: userToNotify.platform ?? '',
                surveyType: surveyKey,
                surveyName: Constants.SurveysTypes[surveyKey]
            })
                .then(response => {
                    setIsAssigningUser(false)
                    if (response && response.data && response.data.code !== undefined && response.data.code === 0) {
                        message.success('¡La encuesta se asignó exitósamente!');
                    } else {
                        console.log("ERROR: " + JSON.stringify(response))
                        message.error("Se produjo un error. Vuelva a intentarlo más tarde.");
                    }
                }).catch(error => {
                console.log("ERROR: " + JSON.stringify(error))
                message.error('Se produjo un error. Por favor, vuelva a intentarlo');
                setIsAssigningUser(false)
            })
        } else {
            message.error('Se produjo un error. Por favor, recargue el sitio y vuelva a intentarlo');
        }
    }

    const removeSurvey = (userId, surveyId) => {
        setIsAssigningUser(true)
        db.ref(`${Constants.MAIN_NODES.SURVEYS_ASSIGNED}/${surveyId}`).remove()
            .then(() => {
                db.ref(`${Constants.MAIN_NODES.USERS}/${userId}/surveysAssignedIds`).set(null)
                    .then(() => {
                        message.success('¡La encuesta se borró exitósamente!');
                        setIsAssigningUser(false)
                    })
                    .catch(error => {
                        console.log("ERROR: " + JSON.stringify(error))
                        message.error('Se produjo un error. Por favor, vuelva a intentarlo');
                        setIsAssigningUser(false)
                    });
            })
            .catch(error => {
                console.log("ERROR: " + JSON.stringify(error))
                message.error('Se produjo un error. Por favor, vuelva a intentarlo');
                setIsAssigningUser(false)
            });
    }

    return (
        <Table className="surveysClientsTableCont" dataSource={dataSource} rowKey="id" size="middle" pagination={true}
               scroll={{x: 1200}}>
            <Column title="Nombre" dataIndex="name" key="name" align="center" width="45%"/>
            <Column title="Correo electrónico" dataIndex="email" key="email" align="center" width="20%"/>
            <Column title="Encuesta" dataIndex="surveyAssigned" key="surveyAssigned" align="center" width="35%"
                    render={(text, record) => {
                        return (<span>
                    {
                        isAssigningUser ?
                            <Button disabled={true} loading>
                                Cargando
                            </Button>
                            :
                            renderSurveyAction(record)
                    }
                </span>)
                    }
                    }/>
        </Table>
    );
};

TableClientsSurveys.propTypes = {
    data: PropTypes.array,
};

export default TableClientsSurveys;
